import {GenericType, TypeGeneric} from './generic-type';

export class ListedResponse<T> extends GenericType {
    @TypeGeneric()
    dataList: T[] = [];

    count: number = 0;

    sequentialRequestId?: number;
}
